module.exports = __webpack_public_path__ + "img/paycam-logo.64c09b21.svg";